import AssigneesTabsMultiSelect from 'components/inputs/dropdowns/AssigneesTabsMultiSelect/AssigneesTabsMultiSelect';
import { List, OrderedSet } from 'immutable';
import React, { FC } from 'react';
import { ProjectGroup } from 'records/ProjectGroup';
import './AssigneesStyles.css';

interface Props {
  id: string;
  assigneesValues: OrderedSet<string>;
  groupAssigneesValues: OrderedSet<string>;
  assigneesOptions: OrderedSet<string>;
  groupAssigneesOptions: List<ProjectGroup>;
  editable: boolean;
  onChange: (values: OrderedSet<string>, type: AssigneesType) => void;
}

type AssigneesType = 'assignees' | 'groupAssignees';

const SinglePunchAssignees: FC<Props> = (props: Props) => {
  const { assigneesValues, groupAssigneesValues } = props;
  const getInitialSelectedAssignees = () => {
    return OrderedSet<string>(assigneesValues);
  };
  const getInitialSelectedGroups = () => {
    return OrderedSet<string>(groupAssigneesValues);
  };
  const extraProps = {
    getInitialSelectedAssignees,
    getInitialSelectedGroups,
  };
  return <AssigneesTabsMultiSelect {...props} {...extraProps} />;
};

export default SinglePunchAssignees;
